<div class="chart-container">
  <app-shap-chart [chartData]="chartData"></app-shap-chart>
  <div class="caption" *ngIf="captions.length > 0">
    <h4 class="caption-title">{{ "metadataPage.prediction.shap.caption.title" | translate }}</h4>
    <p *ngFor="let caption of captions">
      {{ caption.text }}
      <ng-container *ngIf="caption.geneCardsUrl">
        <br />
        {{ "metadataPage.prediction.shap.caption.moreInformation" | translate }}
        <a [href]="caption.geneCardsUrl" target="_blank" rel="noopener noreferrer">GeneCards</a>,
        <a [href]="caption.uniprotUrl" target="_blank" rel="noopener noreferrer">UniProt</a>
      </ng-container>
    </p>
  </div>
</div>
